import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { QueryClient, QueryClientProvider } from "react-query";

import store, { history } from "./store";
import Routes from "./routes";
import { QueryParamProvider } from "use-query-params";
import { BrowserRouter as Router, Route } from "react-router-dom";
import ErrorBoundary from "react-error-boundary";
import Error from "./components/errorPage";
import SuccessSnackbar from "./components/common/sucessSnackbar";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./style/theme";
import darktheme from "./style/darktheme";
import GlobalStyles from "./components/GlobalStyles";
import GlobalStylesDarkTheme from "./components/GlobalStylesDarkTheme";
import SvgComponenttop from "./topsvg.js";
import SvgComponentbot from "./botsvg.js";
import { OrganizationThemeState } from "./context/OrganizationThemeContext";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  const { themeLogin } = OrganizationThemeState() || {};
  const UpdateMyTheme = {
    UpdateTheme: {
      button_color: themeLogin?.button_color || "#009035",
      text_color: themeLogin?.text_color || "#ffffff",
      heading_color: themeLogin?.heading_color || "#68000E",
      theme_color: themeLogin?.theme_color || "#009035",
      link_color: themeLogin?.link_color || "#1295EE",
      table_head_color: themeLogin?.button_color || "#009035",
    },
  };
  const updatedDarkTheme = {
    UpdateTheme: {
      button_color: "#000",
      text_color: "#fff",
      heading_color: "#fff",
      theme_color: "#000",
      link_color: "#fff",
      table_head_color: "#000",
    },
  };
  const apiTheme = { ...theme, ...UpdateMyTheme };
  const darkTheme = { ...darktheme, ...updatedDarkTheme };

  function trackingModuleTime() {
    const loginTime = localStorage.getItem("loginTime");
    const moduleStopTracking = localStorage.getItem("moduleStopTracking");
    const token = localStorage.getItem("token");
    if (window.location.pathname.split("/")[1]) {
      localStorage.setItem("moduleStopTracking", Date.now());
    }
    if (moduleStopTracking || loginTime) {
      const lastActiveModule = localStorage.getItem("lastActiveModule");
      if (lastActiveModule || token !== "") {
        const moduleSpentTime = Date.now() - (moduleStopTracking || loginTime);
        const obj = {
          [window.location.pathname.split("/")[1] || lastActiveModule]:
            moduleSpentTime,
        };
        localStorage.setItem("moduleTracking", JSON.stringify(obj));
        localStorage.removeItem("lastActiveModule");
      }
    }
  }
  window.onbeforeunload = function (e) {
    trackingModuleTime();
  };

  const isThemeDark = /true/i.test(localStorage.getItem("isThemeDark"));

  return (
    <>
      {/* <div className="mui-top" >
        <SvgComponenttop height={366} width={426}  color1={UpdateMyTheme.UpdateTheme.theme_color} color2={UpdateMyTheme.UpdateTheme.button_color} />
      </div> */}

      <div className="mui-top" style={{ color:UpdateMyTheme.UpdateTheme.theme_color}}>
        <SvgComponenttop height={366} width={426}  />
      </div>
      <div className="mui-bot" style={{ color:UpdateMyTheme.UpdateTheme.theme_color}} >
        <SvgComponentbot />
      </div>

      <Provider store={store}>
        <ThemeProvider theme={isThemeDark ? darkTheme : apiTheme}>
          {isThemeDark ? <GlobalStylesDarkTheme /> : <GlobalStyles />}
          <ConnectedRouter history={history}>
            <Router>
              <ErrorBoundary FallbackComponent={Error}>
                <QueryParamProvider ReactRouterRoute={Route}>
                  <QueryClientProvider client={queryClient}>
                    <Routes />
                  </QueryClientProvider>
                </QueryParamProvider>
              </ErrorBoundary>
              <SuccessSnackbar />
            </Router>
          </ConnectedRouter>
        </ThemeProvider>
      </Provider>
    </>
  );
}
